// client/src/utils/templateConfig.js

export function extractVars(text) {
  return [...new Set([...(text || '').matchAll(/\{\{(\w+)\}\}/g)].map((m) => m[1]))];
}

// Reemplaza {{nombre}} por {{1}}..{{n}} y devuelve { metaText, varNames }.
function numberVars(text) {
  const varNames = extractVars(text);
  let metaText = text;
  varNames.forEach((varName, idx) => {
    metaText = metaText.split(`{{${varName}}}`).join(`{{${idx + 1}}}`);
  });
  return { metaText, varNames };
}

function exampleFromVariants(varNames, variants) {
  if (varNames.length === 0) return null;
  const values = varNames.map((name) => {
    const v = variants[name];
    return v?.type === 'fixed' && v.value ? v.value : 'ejemplo';
  });
  return { body_text: [values] };
}

function fullUrl(url, origin) {
  if (!url) return '';
  return url.startsWith('http') ? url : `${origin}${url}`;
}

// Botón para enviar a config: mantiene payload (se sanea en backend antes de Meta).
function buildButton(btn) {
  if (btn.type === 'QUICK_REPLY') {
    const out = { type: 'QUICK_REPLY', text: btn.text };
    if (btn.payload) out.payload = btn.payload;
    return out;
  }
  if (btn.type === 'URL') return { type: 'URL', text: btn.text, url: btn.url };
  return { type: 'PHONE_NUMBER', text: btn.text, phone_number: btn.phone };
}

export function buildStandardConfig(opts) {
  const {
    headerEnabled, headerType, headerText, headerMediaUrl, origin,
    bodyText, variants, footerEnabled, footerText, buttonsEnabled, buttons,
  } = opts;

  const components = [];

  if (headerEnabled) {
    if (headerType === 'TEXT') {
      components.push({ type: 'HEADER', format: 'TEXT', text: headerText });
    } else {
      components.push({ type: 'HEADER', format: headerType, example: { header_handle: [fullUrl(headerMediaUrl, origin)] } });
    }
  }

  const { metaText, varNames } = numberVars(bodyText);
  const bodyComp = { type: 'BODY', text: metaText };
  const example = exampleFromVariants(varNames, variants);
  if (example) bodyComp.example = example;
  components.push(bodyComp);

  if (footerEnabled && footerText.trim()) {
    components.push({ type: 'FOOTER', text: footerText.trim() });
  }

  if (buttonsEnabled && buttons.length > 0) {
    const metaButtons = buttons.filter((b) => b.text.trim()).map(buildButton);
    if (metaButtons.length > 0) components.push({ type: 'BUTTONS', buttons: metaButtons });
  }

  return { components };
}

export function buildCarouselConfig(opts) {
  const { bodyText, bodyVariants, mediaType, buttonStructure, cards, origin } = opts;

  const components = [];

  const { metaText, varNames } = numberVars(bodyText);
  const bodyComp = { type: 'BODY', text: metaText };
  const example = exampleFromVariants(varNames, bodyVariants);
  if (example) bodyComp.example = example;
  components.push(bodyComp);

  const cardComps = cards.map((card) => {
    const inner = [];
    inner.push({ type: 'HEADER', format: mediaType, example: { header_handle: [fullUrl(card.mediaUrl, origin)] } });

    const { metaText: cardText, varNames: cardVars } = numberVars(card.bodyText);
    const cBody = { type: 'BODY', text: cardText };
    const cExample = exampleFromVariants(cardVars, card.variants);
    if (cExample) cBody.example = cExample;
    inner.push(cBody);

    if (buttonStructure.length > 0) {
      const btns = buttonStructure.map((struct, i) => {
        const filled = card.buttons[i] || {};
        return buildButton({ type: struct.type, text: filled.text, url: filled.url, phone: filled.phone, payload: filled.payload });
      });
      inner.push({ type: 'BUTTONS', buttons: btns });
    }

    return { components: inner };
  });

  components.push({ type: 'CAROUSEL', cards: cardComps });

  return { components };
}
